import { queryFetcher } from "@utilities/helpers/queryFetcher";
import { QueryOptions } from "@utilities/helpers/queryParser.types";
import useSWR from "swr";

export function useRetrieveCoach<T>(coachId: string, options: QueryOptions) {
  const endpoint = `/api/v1/coaches/${coachId}`;
  const { data, isValidating, revalidate } = useSWR(
    [endpoint, options],
    queryFetcher,
  );

  const result = data?.data as T;

  return {
    data: result || null,
    error: data?.error || null,
    isLoading: isValidating,
    reload: revalidate,
  };
}
